import React from 'react';
import { range } from '.';
import * as Table from '../Table';
import SkeletonLoader from './Skeleton';

const HeaderItem = ({ last }: { last?: boolean }) => (
  <Table.HeadColumn last={last}>
    <SkeletonLoader widthClass="w-auto" />
  </Table.HeadColumn>
);

const ColumnItem = ({ last }: { last?: boolean }) => (
  <Table.Column last={last}>
    <SkeletonLoader widthClass="w-auto" />
  </Table.Column>
);

export const RowItem = ({ columns = 5 }: { columns?: number }) => (
  <Table.Row>
    {range(columns).map(i => (
      <ColumnItem key={i} last={i === columns - 1} />
    ))}
  </Table.Row>
);

const TableSkeleton = ({
  columns = 5,
  rows = 5,
  tight,
}: Pick<Table.Props, 'tight'> & {
  columns?: number;
  rows?: number;
}) => (
  <Table.Table tight={tight}>
    <Table.Head>
      <Table.HeadRow>
        {range(columns).map(i => (
          <HeaderItem key={i} last={i === columns - 1} />
        ))}
      </Table.HeadRow>
    </Table.Head>
    <Table.Body>
      {range(rows).map(i => (
        <RowItem key={i} columns={columns} />
      ))}
    </Table.Body>
  </Table.Table>
);

export default TableSkeleton;
